import React from 'react';
import { useQuery } from '@apollo/client';
import { Toggle } from '../../../ui/Toggle';
import { PriceViewMode, ToggleOption } from '../../../GeneralAdsPage/types';
import { GetDataForTransformationsQuery } from '../../../../graphql/graphql';
import { getDataForTransformationsQuery } from '../../../../api/queries';
import { useSorting } from '../../../../hooks/useSorting';

interface PriceViewToggleProps {
  options: ToggleOption[];
  selectedValue: PriceViewMode | null;
  onChange: React.Dispatch<React.SetStateAction<PriceViewMode | null>>;
}

export const PriceViewToggle: React.FC<PriceViewToggleProps> = ({
  options,
  selectedValue,
  onChange
}) => {
  const { currentSort, updateSort } = useSorting();

  const { data } = useQuery<GetDataForTransformationsQuery>(
    getDataForTransformationsQuery,
    { fetchPolicy: 'cache-only' }
  );

  const handleChange = (mode: PriceViewMode) => {
    onChange(mode);
    updateSort(currentSort, mode, { mode: true, sortData: data?.sort });
  };

  return (
    <Toggle
      options={options}
      selectedValue={selectedValue || PriceViewMode.PerArea}
      onChange={handleChange}
      cypress="price-view-toggle"
      stat="area-toggle-price"
    />
  );
};
